import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, warehouseValidations } from "./warehouse-add-schema";
import { createWarehouse } from "services/data.internal.service";
import WarehouseInfo from "./components/WarehouseInfo";
import { useNavigate } from "react-router-dom";

function AddWarehouse() {
  const navigate = useNavigate()
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createWarehouseMutation = useMutation(createWarehouse, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(warehouseValidations),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    createWarehouseMutation.mutate(data, {
      onSuccess: () => navigate("/setup/location/add",{state:{warehouseCode:data.warehouseCode,zoneID:data.zoneID}}),
    });
  };
  const createStatus = createWarehouseMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <WarehouseInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus} url="/setup/warehouse" />
      </form>
    </Layout>
  );
}

export default AddWarehouse;
